export const ROUTER_ENFORCEMENT_FLAG = 'hermes.rbac.routerEnforcement'
